export const getCompanyDataPayload = info => {
  return {
    company_data: {
      company_name: info?.name,
      company_currency: info?.selectedStore?.currency,
      primary_store_url: info?.selectedStore?.domain,
      country: info?.address?.country?.code,
      state: info?.address?.country?.code === 'US' ? info?.address?.province : undefined,
    },
  }
}
